const emailContent = {
  path: "email-marketing",
  short: "Email",
  title: "Email Marketing",
  content: {
    hero: {
      title: "Email Marketing",
      subtitle: "Klaviyo, Mailchimp, and More",
      description:
        "Email marketing is one of the most effective ways to retain interest in your brand and gain repeat business",
      button: "Book an Appointment",
    },
    intro: {
      title: "The Power of Email Marketing",
      subtitle: "Direct Engagement with Your Audience",
      description:
        "Effective email marketing goes beyond sending newsletters. It's about creating targeted communications that resonate with your audience, encouraging loyalty and repeat business.",
      image: "/services/hero-email-marketing.webp",
    },
    why: {
      title: "Why Email Marketing?",
      subtitle: "Personalized Communication at Scale",
      description:
        "With email marketing, you can reach your customers directly in their inboxes with personalized messages tailored to their interests, driving engagement and conversions.",
      image: "/services/img1.png",
      list: [
        {
          title: "Marketing Calendars",
          description:
            "Plan and schedule your promotional efforts in advance for maximum impact and efficiency.",
        },
        {
          title: "Transactional Emails",
          description:
            "Automate and optimize the emails your customers receive after taking action on your site, such as making a purchase or signing up for a newsletter.",
        },
        {
          title: "Email Marketing Platforms",
          description:
            "Utilize the best-in-class email service providers for reliable delivery and advanced analytics.",
        },
        {
          title: "Cross Device/Viewer Compliance",
          description:
            "Ensure your emails look great and perform well across all devices and email clients.",
        },
      ],
    },
    whySms: {
      title: "Why Email Marketing?",
      subtitle: "Personalized Communication at Scale",
      description:
        "With email marketing, you can reach your customers directly in their inboxes with personalized messages tailored to their interests, driving engagement and conversions.",
      image: "/services/img1.png",
      list: [
        {
          title: "Marketing Calendars",
          description:
            "Plan and schedule your promotional efforts in advance for maximum impact and efficiency.",
        },
        {
          title: "Transactional Emails",
          description:
            "Automate and optimize the emails your customers receive after taking action on your site, such as making a purchase or signing up for a newsletter.",
        },
        {
          title: "Email Marketing Platforms",
          description:
            "Utilize the best-in-class email service providers for reliable delivery and advanced analytics.",
        },
        {
          title: "Cross Device/Viewer Compliance",
          description:
            "Ensure your emails look great and perform well across all devices and email clients.",
        },
      ],
    },
    features: {
      title: "Email & SMS Marketing Features",
      subtitle: "Effective Campaigns for Customer Engagement",
      description:
        "Our email marketing services encompass everything from strategic planning to execution, ensuring your message reaches and resonates with your audience.",
      list: [
        {
          title: "Email Performance Audit",
          description:
            "Evaluate the effectiveness of past campaigns to inform strategies that improve open rates and conversions.",
        },
        {
          title: "Campaign History Review",
          description:
            "Analyze your email campaign's history to understand trends, successes, and areas for improvement.",
        },
        {
          title: "Delivery Optimization",
          description:
            "Optimize email delivery times and frequency to ensure maximum engagement with your audience.",
        },
        {
          title: "Signup Form Development",
          description:
            "Create custom, branded signup forms to grow your subscriber list and collect valuable customer data.",
        },
        {
          title: "Newsletter Template Design",
          description:
            "Design professional, visually appealing newsletter templates that reflect your brand's identity.",
        },
        {
          title: "Promotional Template Design",
          description:
            "Craft targeted promotional emails with compelling calls-to-action to drive sales and conversions.",
        },
        {
          title: "Audience Segmentation",
          description:
            "Segment your email list based on customer behavior and preferences for more personalized communication.",
        },
        {
          title: "Custom Email Strategy",
          description:
            "Develop a tailored email marketing strategy that aligns with your business goals and audience needs.",
        },
        {
          title: "Email Automation",
          description:
            "Implement email automation workflows for campaigns like welcome series, cart abandonment, and re-engagement.",
        },
        {
          title: "A/B Testing",
          description:
            "Continuously test and optimize your email campaigns for subject lines, content, and design to improve performance.",
        },
        {
          title: "Analytics and Reporting",
          description:
            "Track key performance indicators and provide detailed reports to measure the success of your email campaigns.",
        },
        {
          title: "List Maintenance",
          description:
            "Regularly clean and update your email list to maintain high deliverability and engagement rates.",
        },
        {
          title: "Sending Domain Reputation",
          description:
            "Monitor and manage your sending domain's reputation to ensure your emails reach the inbox.",
        },
      ],
    },
    cta: {
      title: "Enhance Your Email Campaigns Today",
      description:
        "Reach out to us to discover how our email marketing services can help retain your customers and grow your business.",
      button: "Book an Appointment",
    },
  },
};

export default emailContent;
